import React, { useContext } from 'react';
import { FastField as FormikField } from 'formik';
import { FormRow, FormColumn } from '@xo-union/tk-component-form-grid';
import { Field } from '../../gs-component-form';
import Icon from '@xo-union/tk-component-icons';
import ComponentStateContext from '../ComponentStateContext';
import SectionHeader from '../SectionHeader';
import { Person } from '../interfaces';
import styles from './styles.scss';

interface GuestNameProps {
  index: number;
  isLeader: Person['isLeader'];
  leaderFirstName: Person['firstName'];
  replace: (index: number, value: Person) => void;
  remove: (index: number) => void;
  person: Person;
}

const GuestName: React.FC<GuestNameProps> = ({ index, isLeader, remove, replace, leaderFirstName, person }) => {
  const { guestsDeleted, setGuestsDeleted } = useContext(ComponentStateContext);
  const addUnknownName = (): void =>
    replace(index, {
      ...person,
      isLeader: false,
      firstName: `${leaderFirstName}'s`,
      lastName: 'Guest',
    });
  const removeGuest = (): void => remove(index);

  const fieldName = `people.${index}`;
  const firstField = `${fieldName}.firstName`;
  const lastField = `${fieldName}.lastName`;

  return (
    <>
      <div className={styles.nameHeader}>
        <SectionHeader>Guest Name</SectionHeader>
        {!isLeader && (
          <button type="button" onClick={addUnknownName} className={styles.nameUnknownButton}>
            Name unknown?
          </button>
        )}
      </div>
      <FormRow>
        <FormColumn xs md>
          <FormikField
            name={firstField}
            label="First Name"
            id={`${firstField}-field`}
            data-testid={firstField}
            component={Field}
            autoFocus={isLeader} // for accessibility, we focus on the 1st element in the modal when it appears
          />
        </FormColumn>
        <FormColumn xs md>
          <FormikField
            name={lastField}
            label="Last Name"
            id={`${lastField}-field`}
            data-testid={lastField}
            component={Field}
          />
        </FormColumn>
        {!isLeader && (
          <Icon
            name="remove_circle"
            data-testid="removeGuest"
            size="md"
            onClick={(): void => {
              removeGuest();
              setGuestsDeleted(guestsDeleted + 1);
            }}
            className={styles.removeIcon}
          />
        )}
      </FormRow>
    </>
  );
};

export default GuestName;
